import { Swiper, Lazy } from 'swiper/js/swiper.esm.js';

Swiper.use([Lazy]);

new Swiper('.js-products-slider', {
	slidesPerView: 2,
	spaceBetween: 16,
	preloadImages: false,
	lazy: true,
	breakpoints: {
		576: {
			slidesPerView: 3,
		},
		768: {
			slidesPerView: 4,
		},
		992: {
			slidesPerView: 5,
		},
	},
});
